import { gql } from '@apollo/client/core';

export const FIND_USER_BY_MAIL_QUERY = gql`
  query FindUserByEmail($email: String!) {
    users(where: { email: $email, ownerOf_null: true, employeeOf_null: true }) {
      id
      username
      profilePicture {
        id
        url
        formats
      }
      email
    }
  }
`;
